export default __webpack_public_path__ + "static/icons-cbaf8c6bc547d4b013dd2ec5d22967d4.svg";